const THREE = window.THREE;
import store from "@/store";
import { toPoint2D } from '../../utils/threejsUtils'
import { getURNThumbnail, getNodeSortedProperties } from '../../utils/forgeUtils'
import { 
    convertLatLongToXYZCoordinates_Indian, 
    getRotatedDirectionByNorthAngle, 
    bytesToSize,
    ForgeVisiblityMode
} from './forgeService'

export class ForgeObject {
    constructor() {
        this.id;
        this.dbId;
        this.center;
        this.urn = '';

        this.name = '';
    }
    clone() {
        var obj = new ForgeObject();
        obj.id = this.id;
        obj.dbId = this.dbId;
        obj.center = this.center ? this.center.clone() : null;
        obj.urn = this.urn;
        obj.name = this.name;
        return obj;
    }
}
export class Linked360ImageInfo {
    constructor() {
        this.imageId = null;
    }
}
export class ForgeBaseTag {
    constructor() {
        this.id;
        this.name = '';
        this.isMaster = false;
        this.activityId = '';
        this.workPackNumber = '';
        this.workPackTitle = '';
        this.createdOn = '';
        this.createdBy = '';
        this.thumbnailUrl = '';
        this.attachments = [];
        this.comments = [];
        this.linkedTags1 = [];
        this.linkedTags2 = [];
        this.linked360ImageInfo = null;
        this.area2dCoordinates = null;
        this.forgeAssetId = store.state.assetId
    }

    get tagActivities() {
        return store.getters['GET_TAGS_ACTIVITIES'].byTagId[this.id] ?? [];
    }

    get tagActivitiesObjects() {
        return store.getters['GET_TAGS_ACTIVITIES'].byTagId[this.id]?.map(o => store.getters['GET_TAGS_ACTIVITIES'].byActivityNumber[o]) ?? [];
    }

    get activitiesString() {
        return this.tagActivities?.join(', ') ?? '';
    }

    get query() {
        let values = this.tagActivitiesObjects.map(t => t.query).filter(o => o);

        if (!values?.length) return null;

        return values?.join(', ') ?? '';
    }

    get workPackNumberAM () {
        let values = this.tagActivitiesObjects.map(t => t.workPackNumber).filter(o => o);

        if (!values?.length) return null;

        return values?.join(', ') ?? '';
    }
    get _workPackNumber () {
        return this.workPackNumberAM ?? this.workPackNumber;
    }

    get workPackTitleAM () {
        let values = this.tagActivitiesObjects.map(t => t.workPackTitle).filter(o => o);

        if (!values?.length) return null;

        return values?.join(', ') ?? '';
    }
    get _workPackTitle () {
        return this.workPackTitleAM ?? this.workPackTitle;
    }

    get linkedTagsList() {
        return this.linkedTags1.map(l => l.secondLinkedTagId).concat(this.linkedTags2.map(l => l.firstLinkedTagId))
    }

    get area2dPoints(){
        if(!this.area2dCoordinates)
            return [];
        let numbers = this.area2dCoordinates.split(',').map(o => parseFloat(o));
        let points = []
        for (let i = 0; i < numbers.length; i += 3) {
            points.push(new THREE.Vector3(numbers[i], numbers[i + 1], numbers[i + 2]))
        }
        return points;
    }
    set area2dPoints(value) {
        let text = ''
        value.forEach(o => {
            if (text)
                text += ','
            text += `${o.x},${o.y},${o.z}`;
        })
        this.area2dCoordinates = text
    }
    parseComments() {
        if (!this.comments)
            this.comments = [];

        this.comments = this.comments.map(o => Object.assign(new ForgeComment(), o));
    }
    setSameBaseParameters(element) {
        this.id = element.id;
        this.name = element.name;
        this.isMaster = element.isMaster;
        this.activityId = element.activityId;
        this.workPackNumber = element.workPackNumber;
        this.workPackTitle = element.workPackTitle;
        this.createdOn = element.createdOn;
        this.createdBy = element.createdBy;
        this.thumbnailUrl = element.thumbnailUrl;
        this.comments = element.comments ? element.comments.map(o => o.clone()) : [];
        this.attachments = element.attachments ? element.attachments.map(o => o.clone()) : [];
        this.linkedTags1 = element.linkedTags1 ? element.linkedTags1.map(o => o) : [];
        this.linkedTags2 = element.linkedTags2 ? element.linkedTags2.map(o => o) : [];
        this.linked360ImageInfo = element.linked360ImageInfo;
        this.area2dCoordinates = element.area2dCoordinates;
    }
    // shared search properties
    // IMPORANT:: Make sure not to add any object or array without handling its custom validation.
    getSearchProperties() {
        return [
            {
                property: "name",
                title: "Name",
            },
            {
                property: 'createdBy',
                title: 'Created By',
            },
            {
                property: 'activityId',
                title: 'Activity Id',
            },
            {
                property: '_workPackNumber',
                title: 'Work Pack Number',
            },
            {
                property: '_workPackTitle',
                title: 'Work Pack Title',
            },
            {
                property: 'tagActivities',
                title: 'Activity No.',
            }
        ]
    }

    createNewLink(tagId) {
        var link = {
            id: 0,
            firstLinkedTagId: this.id,
            secondLinkedTagId: tagId
        };

        this.linkedTags1.push(link)

        return link;
    }

    removeLinkedTag(tagId) {
        this.linkedTags1 = this.linkedTags1.filter(l => l.secondLinkedTagId != tagId);
        this.linkedTags2 = this.linkedTags2.filter(l => l.firstLinkedTagId != tagId);
    }
}

export class ForgeTagShortInfo {
    constructor(type) {
        this.id;
        this.dbid;
        this.children = [];
        this.name = '';
        this.objectName = '';
        this.thumbnailUrl = '';
        this.workPackNumber = '';
        this.point = null;
        this.type = type ?? 'Equipment';

        this.parseContent();
    }

    clone() {
        var element = new ForgeTagShortInfo();
        element.setSameParameters(this);
        return element;
    }
    
    setSameParameters(element) {
        this.id = element.id;
        this.dbid = element.dbid;
        this.children = element.children ? element.children.map(o => o.clone()) : [];
        this.name = element.name;
        this.objectName = element.objectName;
        this.thumbnailUrl = element.thumbnailUrl;
        this.workPackNumber = element.workPackNumber;
        this.point = element.point ? new THREE.Vector3(element.point.x, element.point.y, element.point.z) : null;
    }

    parseContent() {
        this.point = Object.assign(new THREE.Vector3(), this.point);

        this.children = [];
        
        if (this.dbid) {
            let child = new ForgeObject();
            child.dbId = this.dbid;
            child.center = this.point;
            child.name = this.name;

            this.children = [child];
        }
    }

    getAllDbIds() {
        var result = [];
        if (this.children) {
            result = this.children.map(o => o.dbId);
        }
        return result;
    }

    getPointInView() {
        if (!this.point || (!store.state.viewer?.model && !store.state.unitScale))
            return this.point;
        
        return store.state.forgeService.worldToView3d(this.point, this.point)
    }

    getGlobalPoint(){
        return this.point
    }
}

export class ForgeEquipment extends ForgeBaseTag {
    constructor() {
        super();
        this.cableNo = '';
        this.certificateNo = '';
        this.certifyingAuthority = '';
        this.discipline = '';
        this.equipmentDescription = '';
        this.fireZone = '';
        this.lineNo = '';
        this.location = '';
        this.manufacturer = '';
        this.modelNo = '';
        this.parentTag = '';
        this.poNo = '';
        this.processFunction = '';
        this.serialNo = '';
        this.serviceDescription = '';
        this.system = '';
        this.weight = '';

        this.category;
        this.p_Id = '';
        this.level2D = null;
        this.tagHarvesterId = null;
        this.tagHarvester = null;
        this.point = null;

        this.isIsolated = false;

        this.children = [];
        this.isSelected = false;
        this.matchedSearch = '';
        this.center;
        this.isExpanded = false;
    }

    getSearchProperties() {
        return [
            {
                property: 'categoryTitle',
                title: 'Category',                
            },
            {
                property: 'p_Id',
                title: 'P&ID',
            },
            {
                property: 'cableNo',
                title: 'Cable No.',
            },
            {
                property: 'certificateNo',
                title: 'Certificate No.',
            },
            {
                property: 'certifyingAuthority',
                title: 'Certifying Authority',
            },
            {
                property: 'discipline',
                title: 'Discipline',
            },
            {
                property: 'equipmentDescription',
                title: 'Equipment Description',
            },
            {
                property: 'fireZone',
                title: 'Fire Zone',
            },
            {
                property: 'lineNo',
                title: 'Line No.',
            },
            {
                property: 'location',
                title: 'Location',
            },
            {
                property: 'manufacturer',
                title: 'Manufacturer',
            },
            {
                property: 'modelNo',
                title: 'Model No.',
            },
            {
                property: 'parentTag',
                title: 'Parent Tag',
            },
            {
                property: 'poNo',
                title: 'PO No.',
            },
            {
                property: 'processFunction',
                title: 'Process Function',
            },
            {
                property: 'serialNo',
                title: 'Serial No.',
            },
            {
                property: 'serviceDescription',
                title: 'Service Description',
            },
            {
                property: 'system',
                title: 'System',
            },
            {
                property: 'weight',
                title: 'Weight',
            },

            ...super.getSearchProperties(),
        ]
    }
    // getTagCenter() {
    //     if (this.center)
    //         return this.center;
    //     if (!this.children || this.children.length == 0 || this.level2D)
    //         return this.point.clone().sub(store.state.viewer.model.getGlobalOffset());
    //     this.center = new THREE.Box3().setFromPoints(this.children.map(o => o.center)).getCenter().sub(store.state.viewer.model.getGlobalOffset());
    //     return this.center;
    // }
    get categoryTitle() {
        let category = store.state.categories.find(c => c.id == this.category);
        
        if (category) {
            return category.name;
        } 

        return '';
    }

    getPointInView() {
        if (!this.point || (!store.state.viewer?.model && !store.state.unitScale))
            return this.point;
        return store.state.forgeService.worldToView3d(this.point, this.point)
    }
    getGlobalPoint(){
        return this.point
    }

    getAllDbIds() {
        var result = [];
        if (this.children) {
            result = this.children.map(o => o.dbId);
        }
        return result;
    }
    getAllTaggedChildren() {
        var list = [this];
        if (this.children == null)
            return list;
        for (var i = 0; i < this.children.length; i++) {
            var tagged = this.children[i].getAllTaggedChildren();
            list = list.concat(tagged);
        }
        return list.filter(o => o.children == null);
    }
    getUniqueName(initialName, names) {
        var result = initialName;
        var index = 1;
        while (names.includes(result)) {
            result = initialName + "(" + index + ")";
            index++;
        }
        return result;
    }
    clone() {
        var elem = new ForgeEquipment();
        elem.setSameParameters(this);
        return elem;
    }
    setSameParameters(element) {
        this.setSameBaseParameters(element);
        this.cableNo = element.cableNo;
        this.certificateNo = element.certificateNo;
        this.certifyingAuthority = element.certifyingAuthority;
        this.discipline = element.discipline;
        this.equipmentDescription = element.equipmentDescription;
        this.fireZone = element.fireZone;
        this.lineNo = element.lineNo;
        this.location = element.location;
        this.manufacturer = element.manufacturer;
        this.modelNo = element.modelNo;
        this.parentTag = element.parentTag;
        this.poNo = element.poNo;
        this.processFunction = element.processFunction;
        this.serialNo = element.serialNo;
        this.serviceDescription = element.serviceDescription;
        this.system = element.system;
        this.weight = element.weight;
        this.category = element.category;
        this.p_Id = element.p_Id;
        this.level2D = element.level2D;
        this.tagHarvesterId = element.tagHarvesterId;
        this.tagHarvester = element.tagHarvester;
        this.isIsolated = element.isIsolated;
        this.point = element.point ? new THREE.Vector3(element.point.x, element.point.y, element.point.z) : null;
        this.children = element.children ? element.children.map(o => o.clone()) : null;
    }
    getCategoryColor() {
        if (this.category > 0 && store.state.categories) {
            let category = store.state.categories.find(c => c.id == this.category);

            if (category) {
                return {
                    r: parseInt(category.color.substr(1, 2), 16) / 255,
                    g: parseInt(category.color.substr(3, 2), 16) / 255,
                    b: parseInt(category.color.substr(5, 2), 16) / 255
                }
            }
        }

        return null;
    }
    parseContent() {
        this.attachments = ForgeAttachment.parseAttachments(this.attachments);
        this.parseComments();
        if (!this.children)
            this.children = [];
        this.children = this.children.map(o => Object.assign(new ForgeObject(), o));
        this.children.forEach(o => o.center = Object.assign(new THREE.Vector3(), o.center));
        
        this.point = Object.assign(new THREE.Vector3(), this.point);
    }
    getWatermarkColor() {
        return '#c0669e';
    }
    static getLabelColor(){
        return 0X91517A;
    }
    getLabelColor(){
        return ForgeEquipment.getLabelColor()
    }
    static getLabelColorVector(){
        let color = new THREE.Color(ForgeEquipment.getLabelColor())
        return new THREE.Vector3(color.r,color.g,color.b)
    }
}
export class ForgePipeline extends ForgeBaseTag {
    constructor() {
        super();
        this.lineSize = null;
        this.pipeSpecification = '';
        this.system = '';
        this.subSystem = '';
        this.sequenceNumber = '';
        this.fluidCode = '';
        this.insulationCode = '';
        this.insulationMm = null;
        this.tracingMaxTemperature = null;
        this.tracingMaintenanceTemperature = null;
        this.phase = '';
        this.sourService = '';
        this.lineRouting = '';
        this.operatingPressure = null;
        this.operatingTemperature = null;
        this.pmaxAtTminPressure = null;
        this.pmaxAtTminTemperature = null;
        this.pmaxAtTmaxPressure = null;
        this.pmaxAtTmaxTemperature = null;
        this.designMaxPressure = null;
        this.designMinPressure = null;
        this.designMaxTemperature = null;
        this.designMinTemperature = null;
        this.chemicalCleaning = '';
        this.processCritical = '';
        this.pedFluidState = '';
        this.pedFluidGroup = '';
        this.pedCategory = '';
        this.testConditionsPressure = null;
        this.testConditionsMedium = '';
        this.stressCriticality = '';
        this.stressCalculationNumber = '';
        this.forgeAssetId = 0;
        this.harvesterMatchedValue = '';
        this.point = null;
        this.tagHarvesterId = null;
        this.tagHarvester = null;
        this.children = [];
        this.isSelected = false;
    }

    getSearchProperties() {
        return [
            { property: 'lineSize', title: 'Line Size' },
            { property: 'pipeSpecification', title: 'Pipe Specification' },
            { property: 'system', title: 'System' },
            { property: 'subSystem', title: 'Sub System' },
            { property: 'sequenceNumber', title: 'Sequence Number' },
            { property: 'fluidCode', title: 'Fluid Code' },
            { property: 'insulationCode', title: 'Insulation Code' },
            { property: 'insulationMm', title: 'Insulation mm' },
            { property: 'tracingMaxTemperature', title: 'Tracing - Max Temperature' },
            { property: 'tracingMaintenanceTemperature', title: 'Tracing - Maintenance Temperature' },
            { property: 'phase', title: 'Phase' },
            { property: 'sourService', title: 'Sour Service' },
            { property: 'lineRouting', title: 'Line Routing' },
            { property: 'operatingPressure', title: 'Operating - Pressure' },
            { property: 'operatingTemperature', title: 'Operating - Temperature' },
            { property: 'pmaxAtTminPressure', title: 'Pmax @ Tmin - Pressure' },
            { property: 'pmaxAtTminTemperature', title: 'Pmax @ Tmin - Temperature' },
            { property: 'pmaxAtTmaxPressure', title: 'Pmax @ Tmax - Pressure' },
            { property: 'pmaxAtTmaxTemperature', title: 'Pmax @ Tmax - Temperature' },
            { property: 'designMaxPressure', title: 'Design - Maximum Pressure' },
            { property: 'designMinPressure', title: 'Design - Minimum Pressure' },
            { property: 'designMaxTemperature', title: 'Design - Maximum Temperature' },
            { property: 'designMinTemperature', title: 'Design - Minimum Temperature' },
            { property: 'chemicalCleaning', title: 'Chemical Cleaning' },
            { property: 'processCritical', title: 'Process Critical' },
            { property: 'pedFluidState', title: 'PED - Fluid State' },
            { property: 'pedFluidGroup', title: 'PED - Fluid Group' },
            { property: 'pedCategory', title: 'PED - Category' },
            { property: 'testConditionsPressure', title: 'Test Conditions - Pressure' },
            { property: 'testConditionsMedium', title: 'Test Conditions - Medium' },
            { property: 'stressCriticality', title: 'Stress - Criticality' },
            { property: 'stressCalculationNumber', title: 'Stress - Calculation Number' },
            { property: 'harvesterMatchedValue', title: 'Pipeline' },
            ...super.getSearchProperties(),
        ];
    }

    clone() {
        var e = new ForgePipeline();
        e.setSameParameters(this);
        return e;
    }

    setSameParameters(element) {
        super.setSameBaseParameters(element);
        this.lineSize = element.lineSize;
        this.pipeSpecification = element.pipeSpecification;
        this.system = element.system;
        this.subSystem = element.subSystem;
        this.sequenceNumber = element.sequenceNumber;
        this.fluidCode = element.fluidCode;
        this.insulationCode = element.insulationCode;
        this.insulationMm = element.insulationMm;
        this.tracingMaxTemperature = element.tracingMaxTemperature;
        this.tracingMaintenanceTemperature = element.tracingMaintenanceTemperature;
        this.phase = element.phase;
        this.sourService = element.sourService;
        this.lineRouting = element.lineRouting;
        this.operatingPressure = element.operatingPressure;
        this.operatingTemperature = element.operatingTemperature;
        this.pmaxAtTminPressure = element.pmaxAtTminPressure;
        this.pmaxAtTminTemperature = element.pmaxAtTminTemperature;
        this.pmaxAtTmaxPressure = element.pmaxAtTmaxPressure;
        this.pmaxAtTmaxTemperature = element.pmaxAtTmaxTemperature;
        this.designMaxPressure = element.designMaxPressure;
        this.designMinPressure = element.designMinPressure;
        this.designMaxTemperature = element.designMaxTemperature;
        this.designMinTemperature = element.designMinTemperature;
        this.chemicalCleaning = element.chemicalCleaning;
        this.processCritical = element.processCritical;
        this.pedFluidState = element.pedFluidState;
        this.pedFluidGroup = element.pedFluidGroup;
        this.pedCategory = element.pedCategory;
        this.testConditionsPressure = element.testConditionsPressure;
        this.testConditionsMedium = element.testConditionsMedium;
        this.stressCriticality = element.stressCriticality;
        this.stressCalculationNumber = element.stressCalculationNumber;
        this.forgeAssetId = element.forgeAssetId;
        this.point = element.point ? new THREE.Vector3(element.point.x, element.point.y, element.point.z) : null;
        this.tagHarvesterId = element.tagHarvesterId;
        this.tagHarvester = element.tagHarvester;
        this.children = element.children ? element.children.map(o => o.clone()) : null;
        this.harvesterMatchedValue = element.harvesterMatchedValue;
    }

    parseContent() {
        this.attachments = ForgeAttachment.parseAttachments(this.attachments);
        this.parseComments();
        if (!this.children) this.children = [];
        this.children = this.children.map(o => Object.assign(new ForgeObject(), o));
        this.children.forEach(o => o.center = Object.assign(new THREE.Vector3(), o.center));
        this.point = Object.assign(new THREE.Vector3(), this.point);
    }
    
    getPointInView() {
        if (!this.point || (!store.state.viewer?.model && !store.state.unitScale))
            return this.point;
        return store.state.forgeService.worldToView3d(this.point, this.point)
    }
    getGlobalPoint(){
        return this.point
    }

    getAllDbIds() {
        var result = [];
        if (this.children) {
            result = this.children.map(o => o.dbId);
        }
        return result;
    }
    getAllTaggedChildren() {
        var list = [this];
        if (this.children == null)
            return list;
        for (var i = 0; i < this.children.length; i++) {
            var tagged = this.children[i].getAllTaggedChildren();
            list = list.concat(tagged);
        }
        return list.filter(o => o.children == null);
    }
    getUniqueName(initialName, names) {
        var result = initialName;
        var index = 1;
        while (names.includes(result)) {
            result = initialName + "(" + index + ")";
            index++;
        }
        return result;
    }

    getWatermarkColor() {
        return '#c0669e';
    }
    static getLabelColor(){
        return 0X91517A;
    }
    getLabelColor(){
        return ForgePipeline.getLabelColor()
    }
    static getLabelColorVector(){
        let color = new THREE.Color(ForgePipeline.getLabelColor())
        return new THREE.Vector3(color.r,color.g,color.b)
    }
}
export class ForgeStructural extends ForgeBaseTag {
    constructor() {
        super();
        this.point = null;
        this.tagHarvesterId = null;
        this.children = [];

        this.type = '';
        this.description = '';
        this.spec = '';
        this.weight = '';

        this.isSelected = false;
    }

    getSearchProperties() {
        return [
            {
                property: 'type',
                title: 'Type',
            },
            {
                property: 'description',
                title: 'Description',
            },
            {
                property: 'spec',
                title: 'Spec',
            },
            {
                property: 'weight',
                title: 'Weight',
            },
            ...super.getSearchProperties(),
        ]
    }

    clone() {
        var e = new ForgeStructural();
        e.setSameParameters(this);
        return e;
    }

    setSameParameters(element) {
        this.setSameBaseParameters(element);
        this.type = element.type;
        this.description = element.description;
        this.spec = element.spec;
        this.weight = element.weight;
        this.point = element.point ? element.point.clone() : null;
        this.children = element.children ? element.children.map(o => o.clone()) : null;
        this.tagHarvesterId = element.tagHarvesterId;
    }

    parseContent() {
        this.attachments = ForgeAttachment.parseAttachments(this.attachments);
        this.parseComments();
        if (!this.children) this.children = [];
        this.children = this.children.map(o => Object.assign(new ForgeObject(), o));
        this.children.forEach(o => o.center = Object.assign(new THREE.Vector3(), o.center));
        this.point = Object.assign(new THREE.Vector3(), this.point);
    }
    
    getPointInView() {
        if (!this.point || (!store.state.viewer?.model && !store.state.unitScale))
            return this.point;
        return store.state.forgeService.worldToView3d(this.point, this.point)
    }
    getGlobalPoint(){
        return this.point
    }

    getAllDbIds() {
        var result = [];
        if (this.children) {
            result = this.children.map(o => o.dbId);
        }
        return result;
    }
    getAllTaggedChildren() {
        var list = [this];
        if (this.children == null)
            return list;
        for (var i = 0; i < this.children.length; i++) {
            var tagged = this.children[i].getAllTaggedChildren();
            list = list.concat(tagged);
        }
        return list.filter(o => o.children == null);
    }
    getUniqueName(initialName, names) {
        var result = initialName;
        var index = 1;
        while (names.includes(result)) {
            result = initialName + "(" + index + ")";
            index++;
        }
        return result;
    }

    getWatermarkColor() {
        return '#c0669e';
    }
    static getLabelColor(){
        return 0X91517A;
    }
    getLabelColor(){
        return ForgeStructural.getLabelColor()
    }
    static getLabelColorVector(){
        let color = new THREE.Color(ForgeStructural.getLabelColor())
        return new THREE.Vector3(color.r,color.g,color.b)
    }
}
export class ForgeAnnotation extends ForgeBaseTag {
    constructor() {
        super();
        this.description = '';
        this.level = '';
        this.point = null;
        this.level2D = null;
        this.category = 0;
        this.location = '';
        this.children = [];
        this.p_Id = '';
        this.isPrivate = false;
        this.createdById = null;
        this.priority = "";

        this.isSelected = false;
        this.isExpanded = false;
        this.selected3dDbids = null;
    }

    getSearchProperties() {
        return [            
            {
                'property': 'p_Id',
                'title': 'P_Id',
            },
            {
                'property': 'description',
                'title': 'Description',
            },
            {
                'property': 'priority',
                'title': 'Priority',
            },
            {
                'property': "categoryTitle",
                'title': "Category",
            },
            {
                'property': "level",
                'title': "Area",
            },
            {
                'property': "tq",
                'title': "TQ",
            },
            {
                'property': "location",
                'title': "Location",
            },
            {
                property: 'query',
                title: 'TQ',
            },
            ...super.getSearchProperties(),
        ]
    }

    get categoryTitle() {
        let category = store.state.categories.find(c => c.id == this.category);
        
        if (category) {
            return category.name;
        } 

        return '';
    }

    getAllDbIds() {
        var result = [];
        if (this.children) {
            result = this.children.map(o => o.dbId);
        }
        return result;
    }
    getAllTaggedChildren() {
        var list = [this];
        if (this.children == null)
            return list;
        for (var i = 0; i < this.children.length; i++) {
            var tagged = this.children[i].getAllTaggedChildren();
            list = list.concat(tagged);
        }
        return list.filter(o => o.children == null);
    }
    parseContent() {
        if (this.point)
            this.point = new THREE.Vector3(this.point.x, this.point.y, this.point.z);
        this.attachments = ForgeAttachment.parseAttachments(this.attachments);
        if (!this.children)
            this.children = [];
        this.children = this.children.map(o => Object.assign(new ForgeObject(), o));
        this.children.forEach(o => o.center = Object.assign(new THREE.Vector3(), o.center));

        this.parseComments();
    }
    clone() {
        var elem = new ForgeAnnotation();
        elem.setSameParameters(this);
        return elem;
    }
    getPointInView() {
        if (!this.point || (!store.state.viewer?.model && !store.state.unitScale))
            return this.point;
        return store.state.forgeService.worldToView3d(this.point, this.point)
    }
    getGlobalPoint(){
        return this.point
    }
    getCategoryColor() {
        if (this.category > 0 && store.state.categories) {
            let category = store.state.categories.find(c => c.id == this.category);

            if (category) {
                return {
                    r: parseInt(category.color.substr(1, 2), 16) / 255,
                    g: parseInt(category.color.substr(3, 2), 16) / 255,
                    b: parseInt(category.color.substr(5, 2), 16) / 255
                }
            }
        }

        return null;
    }
    setSameParameters(element) {
        this.setSameBaseParameters(element);
        this.description = element.description;
        this.level = element.level;
        this.level2D = element.level2D;
        this.category = element.category;
        this.selected3dDbids = element.selected3dDbids;
        this.point = element.point ? new THREE.Vector3(element.point.x, element.point.y, element.point.z) : new THREE.Vector3();
        this.children = element.children ? element.children.map(o => o.clone()) : null;
        this.p_Id = element.p_Id;
        this.isPrivate = element.isPrivate;
        this.createdById = element.createdById;
        this.priority = element.priority;

        this.location = element.location;
        this.tq = element.tq;
    }
    getWatermarkColor() {
        return '#51a0c4'
    }
    static getLabelColor(viewType){
        return viewType === '3d' ? 0X104d68 :0X51a0c4;
    }
    getLabelColor(){
        return ForgeAnnotation.getLabelColor()
    }
    static getLabelColorVector(viewType){
        let color = new THREE.Color(ForgeAnnotation.getLabelColor(viewType))
        return new THREE.Vector3(color.r,color.g,color.b)
    }
}
export class ForgeInspection extends ForgeBaseTag {
    constructor() {
        super();
        this.subTags = [];
        this.point = null;
        this.level2D = null;
        this.children = [];
        this.isFetched = false,

        this.pltName = ''; //Unit
        this.pltCode = ''; //Unit Id
        this.macType = ''; //Item Type
        this.lno = ''; //Line No.
        this.lnoCode = 0; //Line No. Id
        this.ctgName = ''; //Category
        this.clName = ''; //CL No.
        this.macFrom = ''; //FROM
        this.macTo = ''; //TO
        this.lawName = ''; //General regulations
        this.makDate = null; //Fab. Date
        this.mkrName = ''; //Manufacturer
        this.impName = ''; //Criticality
        this.stName = ''; //Type
        this.fncName = ''; //Function
        this.flwClsName = ''; //Flow Type
        this.flwName = ''; //Flow Name
        this.useCase = ''; //Status
        this.ispDate = null; //Inspection Date
        this.cr = null; //Corrosion rate
        this.rl = null; //Remaining Life
        this.el = null; //End of life
        this.rt = null; //Remaining Thickness
        this.nIspDate = null; //Next Inspection Date
        this.offerNextInspDate = null; //Next Visual/NDI Inspection Date
        this.pressure1 = ''; //Ope. Press.1
        this.pressure2 = ''; //Ope. Press.2
        this.pressure3 = ''; //Ope. Press.3
        this.pressure4 = ''; //Ope. Press.4
        this.pressureUnit = ''; //Unit Type
        this.temperature1 = ''; //Ope. Temp.1
        this.temperature2 = ''; //Ope. Temp.2
        this.temperature3 = ''; //Ope. Temp.3
        this.temperature4 = ''; //Ope. Temp.4
        this.temperatureUnit = ''; //Temperature Type
        this.lawName1 = ''; //CODE1
        this.lawName2 = ''; //CODE2
        this.lawName3 = ''; //CODE3
        this.offerLastInspDate = null; //LatestVisual Inspection Date
        this.clNo1 = ''; //CL No.1
        this.clNo2 = ''; //CL No.2
        this.fluidClassification1 = ''; // Fluid Class.1
        this.fluidClassification2 = ''; // Fluid Class.2

        this.ispDateDays = null; //Thickness Inspection Days
        this.offerLastInspDateDays = null; //Visual Inspection Days
        this.nearestLastDateDays = null;

        this.nIspDateDays = null; //Thickness Inspection Days
        this.offerNextInspDateDays = null; //Visual Inspection Days
        this.closestNextDateDays = null;

        this.baseStyleUrl = '';
        this.thickUrl = '';

        this.masterType = '';

        this.selected3dDbids = null;
        this.isSelected = false;
        this.pinColor = '#0f7968';
    }

    getSearchProperties() {
        return [
            ...super.getSearchProperties(),
            {
                'property': "pltName",
                'title': "Unit",
            },
            {
                'property': "pltCode",
                'title': "Unit Code",
            },
            {
                'property': "macType",
                'title': "Item Type",
            },
            {
                'property': "lno",
                'title': "Line No.",
            },
            {
                'property': "lnoCode",
                'title': "Line No. Code",
            },
            {
                'property': 'ctgName',
                'title': 'Category',
            },
            {
                'property': 'clNo1',
                'title': 'CL No.1',
            },
            {
                'property': 'clNo2',
                'title': 'CL No.2',
            },
            {
                'property': 'macFrom',
                'title': 'FROM',
            },
            {
                'property': 'macTo',
                'title': 'TO',
            },
            {
                'property': 'lawName1',
                'title': 'Code 1',
            },
            {
                'property': 'lawName2',
                'title': 'Code 2',
            },
            {
                'property': 'lawName3',
                'title': 'Code 3',
            },
            {
                'property': 'OpePress1',
                'title': 'Ope. Press.1',
            },
            {
                'property': 'OpePress2',
                'title': 'Ope. Press.2',
            },
            {
                'property': 'OpeTemp1',
                'title': 'Ope. Temp.1',
            },
            {
                'property': 'OpeTemp2',
                'title': 'Ope. Temp.2',
            },
            {
                'property': 'mkrName',
                'title': 'Manufacturer',
            },
            {
                'property': 'impName',
                'title': 'Criticality',
            },
            {
                'property': 'stName',
                'title': 'Type',
            },
            {
                'property': 'flwClsName',
                'title': 'Fluid Type',
            },
            {
                'property': 'fluidClassification1',
                'title': 'Fluid Class.1',
            },
            {
                'property': 'fluidClassification2',
                'title': 'Fluid Class.2',
            },
            {
                'property': 'useCase',
                'title': 'Status',
            },
            {
                'property': 'cr',
                'title': 'Corrosion rate',
            },
            {
                'property': 'rl',
                'title': 'Remaining Life',
            },
            {
                'property': 'el',
                'title': 'End of life',
            },
            {
                'property': 'rt',
                'title': 'Remaining Thickness',
            },
            {
                'property': 'nIspDate',
                'title': 'Next Inspection Date<THK>',
            },
            {
                'property': 'offerNextInspDate',
                'title': 'Next Inspection Date<VI/NDI>',
            },
            {
                'property': 'clName',
                'title': 'CL No.',
            },
            {
                'property': 'lawName',
                'title': 'General regulations',
            },
            {
                'property': 'flwName',
                'title': 'Flow Name',
            }
        ]
    }

    get category () {
        return this.ctgName;
    }

    get categoryTitle() {
        if (this.isFetched) return this.ctgName;

        let category = store.state.categories.find(c => c.id == this.ctgName);
        
        if (category) {
            return category.name;
        } 

        return '';
    }

    getCategoryColor() {
        if (this.category > 0 && store.state.categories) {
            let category = store.state.categories.find(c => c.id == this.category);

            if (category) {
                return {
                    r: parseInt(category.color.substr(1, 2), 16) / 255,
                    g: parseInt(category.color.substr(3, 2), 16) / 255,
                    b: parseInt(category.color.substr(5, 2), 16) / 255
                }
            }
        }

        return null;
    }

    getAllDbIds() {
        var result = [];
        if (this.children) {
            result = this.children.map(o => o.dbId);
        }
        return result;
    }
    getAllTaggedChildren() {
        var list = [this];
        if (this.children == null)
            return list;
        for (var i = 0; i < this.children.length; i++) {
            var tagged = this.children[i].getAllTaggedChildren();
            list = list.concat(tagged);
        }
        return list.filter(o => o.children == null);
    }

    parseContent() {
        if (this.point)
            this.point = new THREE.Vector3(this.point.x, this.point.y, this.point.z);
        this.attachments = ForgeAttachment.parseAttachments(this.attachments);
        this.parseComments();
        if (!this.subTags)
            this.subTags = [];
        this.subTags = this.subTags.map(o => Object.assign(new ForgeInspectionSubTag(), o));
        this.subTags.forEach(o => o.point = Object.assign(new THREE.Vector3(), o.point));

        if (!this.children)
            this.children = [];
        this.children = this.children.map(o => Object.assign(new ForgeObject(), o));
        this.children.forEach(o => o.center = Object.assign(new THREE.Vector3(), o.center));
    }
    clone() {
        var elem = new ForgeInspection();
        elem.setSameParameters(this);
        return elem;
    }
    getPointInView() {
        if (!this.point || (!store.state.viewer?.model && !store.state.unitScale))
            return this.point;
        return store.state.forgeService.worldToView3d(this.point, this.point)
    }
    getGlobalPoint(){
        return this.point
    }
    setSameParameters(element) {
        this.setSameBaseParameters(element);
        this.pltName = element.pltName;
        this.pltCode = element.pltCode;
        this.macType = element.macType;
        this.lno = element.lno;
        this.lnoCode = element.lnoCode;
        this.ctgName = element.ctgName
        this.clName = element.clName
        this.macFrom = element.macFrom
        this.macTo = element.macTo
        this.lawName = element.lawName
        this.makDate = element.makDate
        this.mkrName = element.mkrName
        this.impName = element.impName
        this.stName = element.stName
        this.fncName = element.fncName
        this.flwClsName = element.flwClsName
        this.flwName = element.flwName
        this.useCase = element.useCase
        this.ispDate = element.ispDate
        this.cr = element.cr
        this.rl = element.rl
        this.el = element.el
        this.rt = element.rt
        this.nIspDate = element.nIspDate
        this.offerNextInspDate = element.offerNextInspDate
        this.pressure1 = element.pressure1
        this.pressure2 = element.pressure2
        this.pressure3 = element.pressure3
        this.pressure4 = element.pressure4
        this.pressureUnit = element.pressureUnit
        this.temperature1 = element.temperature1
        this.temperature2 = element.temperature2
        this.temperature3 = element.temperature3
        this.temperature4 = element.temperature4
        this.temperatureUnit = element.temperatureUnit
        this.lawName1 = element.lawName1
        this.lawName2 = element.lawName2
        this.lawName3 = element.lawName3
        this.offerLastInspDate = element.offerLastInspDate
        this.clNo1 = element.clNo1
        this.clNo2 = element.clNo2
        this.fluidClassification1 = element.fluidClassification1
        this.fluidClassification2 = element.fluidClassification2

        this.ispDateDays = element.ispDateDays
        this.offerLastInspDateDays =  element.offerLastInspDateDays
        this.nIspDateDays =  element.nIspDateDays
        this.nearestLastDateDays = element.nearestLastDateDays
        this.offerNextInspDateDays =  element.offerNextInspDateDays
        this.closestNextDateDays = element.closestNextDateDays

        this.baseStyleUrl = element.baseStyleUrl;
        this.thickUrl = element.thickUrl;

        this.masterType = element.masterType;

        this.isFetched = element.isFetched;
        this.subTags = element.subTags ? element.subTags.map(o => o.clone()) : [];
        this.children = element.children ? element.children.map(o => o.clone()) : null;
        this.point = element.point ? new THREE.Vector3(element.point.x, element.point.y, element.point.z) : new THREE.Vector3();
        this.selected3dDbids = element.selected3dDbids;

        this.pinColor = '#0f7968'
    }
    getWatermarkColor() {
        return '#0f7968';
    }
    static getLabelColor(){
        return 0x379987
    }
    getLabelColor(){
        return ForgeInspection.getLabelColor()
    }
    getPinVector() {
        let color = new THREE.Color(this.pinColor)
        return new THREE.Vector3(color.r, color.g, color.b)
    }
    static getLabelColorVector(){
        let color = new THREE.Color(ForgeInspection.getLabelColor())
        return new THREE.Vector3(color.r,color.g,color.b)
    }
}
export class ForgeInspectionSubTag {
    constructor() {
        this.id;
        this.name = '';
        this.point = null;
    }
    clone() {
        var elem = new ForgeInspectionSubTag();
        elem.setSameParameters(this);
        return elem;
    }
    getPointInView() {
        if (!this.point || (!store.state.viewer?.model && !store.state.unitScale))
            return this.point;
        return store.state.forgeService.worldToView3d(this.point, this.point)
    }
    getGlobalPoint(){
        return this.point
    }
    setSameParameters(element) {
        this.id = element.id;
        this.name = element.name;
        this.point = element.point ? new THREE.Vector3(element.point.x, element.point.y, element.point.z) : new THREE.Vector3();
    }
}
export class ForgeScaffold extends ForgeBaseTag {
    constructor() {
        super();
        this.location = "";
        this.state = '';
        this.scale = new THREE.Vector3();
        this.position = new THREE.Vector3();
        this.max = new THREE.Vector3();
        this.type = 'scaffold';//scaffold || permit || container
        this.status = '';
        this.workpackNumber = '';
        this.description = '';

        this.isSelected = false;
    }

    getSearchProperties() {
        return [
            ...super.getSearchProperties(),
            {
                'property': "state",
                'title': "State",
            },
            {
                'property': "status",
                'title': "Status",
            },
            {
                'property': "workpackNumber",
                'title': "Workpack No.",
            },
            {
                'property': "description",
                'title': "Description",
            },
            {
                'property': "location",
                'title': "Location",
            },
            {
                'property': "masterType",
                'title': "Type",
            }
        ]
    }

    get length() {
        return Number.parseFloat((this.max.y * this.scale.y).toFixed(2));
    }
    set length(value) {
        this.max.y = Number.parseFloat(value) / this.scale.y;
    }
    get height() {
        return Number.parseFloat((this.max.z * this.scale.z).toFixed(2));
    }
    set height(value) {
        this.max.z = Number.parseFloat(value) / this.scale.z;
    }

    get width() {
        return Number.parseFloat((this.max.x * this.scale.x).toFixed(2));
    }
    set width(value) {
        this.max.x = Number.parseFloat(value) / this.scale.x;
    }

    get viewPosition() {
        if (!store.state.viewer || !store.state.viewer.model)
            return null;
        return store.state.forgeService.worldToView3d(this.position, this.position)
    }
    set viewPosition(value) {
        if (!store.state.viewer || !store.state.viewer.model)
            return;
        this.position = store.state.forgeService.view3dToWorld(value)
    }
    getBox() {
        let position = this.viewPosition;
        var viewX = store.state.forgeService.worldToView3dLength(this.max.x * this.scale.x)
        var viewY = store.state.forgeService.worldToView3dLength(this.max.y * this.scale.y)
        var viewZ = store.state.forgeService.worldToView3dLength(this.max.z * this.scale.z)
        let min = new THREE.Vector3(position.x - .5 * viewX, position.y - .5 * viewY, position.z - .5 * viewZ);
        let max = new THREE.Vector3(position.x + .5 * viewX, position.y + .5 * viewY, position.z + .5 * viewZ);
        return new THREE.Box3(min, max);
    }
    getPointInView() {
        if (!this.position || (!store.state.viewer?.model && !store.state.unitScale))
            return this.position;

        return store.state.forgeService.worldToView3d(this.position, this.position)
    }
    getGlobalPoint(){
        return this.position
    }
    getForgeColor() {
        let index = store.state.forgeService.scaffoldStates.findIndex(o => o.state == this.state);
        if (index == 0)
            return '#92D050';
        else if (index == 1)
            return '#ffa500';
        else if (index == 2)
            return '#ff0000';
        return this.getWatermarkColor();
    }
    clone() {
        let copy = new ForgeScaffold();
        copy.setSameBaseParameters(this);
        copy.location = this.location;
        copy.state = this.state;
        copy.scale = this.scale.clone();
        copy.position = this.position.clone();
        copy.max = this.max.clone();
        copy.status = this.status;
        copy.workpackNumber = this.workpackNumber;
        copy.description = this.description;
        copy.type = this.type;
        return copy;
    }

    setScale(x, y, z) {
        this.scale = new THREE.Vector3(x, y, z);
    }

    setPosition(x, y, z) {
        this.viewPosition = new THREE.Vector3(x, y, z);
    }

    parseContent() {
        this.attachments = ForgeAttachment.parseAttachments(this.attachments);
        this.parseComments();
        
        this.position = Object.assign(new THREE.Vector3(), this.position);
        this.max = Object.assign(new THREE.Vector3(), this.max);
        this.scale = Object.assign(new THREE.Vector3(), this.scale);
    }

    setMax(x, y, z) {
        this.max = new THREE.Vector3(x, y, z)
    }
    getWatermarkColor() {
        if (this.isScaffold())
            return '#ffb548';
        else if (this.isPermit())
            return '#f08a2b';
        else if (this.isContainer())
            return '#6d2251';
    }
    getPinVector() {
        let color = new THREE.Color(this.getForgeColor())
        return new THREE.Vector3(color.r, color.g, color.b)
    }
    static getLabelColor(type, viewType){
        if (type == 'scaffold')
            return viewType == '3d' ? 0xc66408 : 0Xffb548;
        else if (type == 'permit')
            return viewType == '3d' ? 0xff5211 : 0Xf08a2b;
        else if (type == 'container')
            return viewType == '3d' ? 0X39122b : 0X6d2251;
    }
    getLabelColor(){
        return ForgeScaffold.getLabelColor(this.type)
    }
    static getLabelColorVector(type, viewType){
        let color = new THREE.Color(ForgeScaffold.getLabelColor(type, viewType))
        return new THREE.Vector3(color.r,color.g,color.b)
    }

    isScaffold() {
        return this.type == 'scaffold'
    }
    isPermit() {
        return this.type == 'permit'
    }
    isContainer() {
        return this.type == 'container'
    }
    getFriendlyTypeName() {
        if (!this.type)
            return '';
        return this.type.charAt(0).toUpperCase() + this.type.slice(1)
    }
}

export class MappingViewersInfo {
    constructor() {
        this.min;
        this.max;
    }

    isReady() {
        if (!this.min || !this.max)
            return false;
        return true;
    }
    _3dTo2d(generalViewPoint) {
        let planBox = store.state.planViewer.model.getBoundingBox()
        let minPt2d = planBox.min
        let maxPt2d = planBox.max;
        minPt2d.setZ(0);
        maxPt2d.setZ(0);

        //get moving distance
        var globalDist = this.min.distanceTo(this.max);
        var planDist = minPt2d.distanceTo(maxPt2d);
        var movingDistance2D = toPoint2D(this.min).distanceTo(toPoint2D(generalViewPoint));
        var movingDist = (movingDistance2D * planDist) / globalDist;

        //moving vector from point1 in plan view to result point
        var movingVec = new THREE.Vector3(generalViewPoint.x - this.min.x, generalViewPoint.y - this.min.y, 0);
        movingVec = movingVec.normalize().multiplyScalar(movingDist);
        return minPt2d.clone().add(movingVec);
    }
    _2dTo3d(planPoint) {
        let plabBox = store.state.planViewer.model.getBoundingBox()
        let minPt2d = plabBox.min
        let maxPt2d = plabBox.max;
        maxPt2d.setZ(0);

        var globalDist = this.min.distanceTo(this.max);
        var planDist = toPoint2D(minPt2d).distanceTo(toPoint2D(maxPt2d));
        var planMovingDist = toPoint2D(minPt2d).distanceTo(toPoint2D(planPoint));
        var movingDist3D = (planMovingDist * globalDist) / planDist;

        var movingVec = new THREE.Vector3(planPoint.x - minPt2d.x, planPoint.y - minPt2d.y, 0);
        movingVec = movingVec.normalize().multiplyScalar(movingDist3D);
        return this.min.clone().add(movingVec);
    }

}
export class PointCloudModelInfo {
    constructor() {
        this.id;
        this.name = '';
        this.url = '';
        this.isOnlyURL = '';
        this.createdOn = '';
        this.createdBy = '';

        this.isShown = false;
        this.isSelected = false;
    }
}
export class PointCloudDownload {
    constructor() {
        this.id;
        this.name = '';
        this.createdOn = '';
        this.createdBy = '';
        this.assetName = '';
        this.email = '';
        this.outputType = '';//fls || lfm || recap
        this.downloadUrl = '';
        this.imagesList = [];

        this.isShown = false;
    }
}
export class ForgeLevel {
    constructor() {
        this.id;
        this.name = '';
        this.bottomElevation = 0;
        this.topElevation = 0;
        this.east = 0;
        this.west = 0;
        this.north = 0;
        this.south = 0;
        this.isExpanded = false;
        this.isCropped = false;
        this.dbids = '';
        this.openIn3D = true;

        this.isSelected = false;
        this.isUploading = false;
        //level plan info
        this.planUrn = null;
        this.planImageUrl = null;//saved in db
        this.thumbnailUrl = '';//detected automatically from pdf urn
        this.planWidth = 0;
        this.planHeight = 0;
        this.mappingViewersPointsInfo = null;
        this.isShowingIn3D = false;
        this.isSelectedToCrop = false;
    }
    get dbidsList(){
        return this.dbids?this.dbids.split(',').map(o=>parseInt(o)):[]
    }
    set dbidsList(value){
        this.dbids = value.join(',')
    }
    getViewCropBox() {
        // min and max points of the cropBox calculated from user inputs (west, south, east, north)
        let min = store.state.forgeService.worldToView3d(new THREE.Vector3(this.west, this.south, this.bottomElevation))
        let max = store.state.forgeService.worldToView3d(new THREE.Vector3(this.east, this.north, this.topElevation))

        let minPoint = new THREE.Vector3(min.x, min.y, min.z);
        let maxPoint = new THREE.Vector3(max.x, max.y, max.z);

        // Check if the min and max points of the cropBox are within the model boundaries.
        // Suppose the min or max points are not within the model boundaries. In that case, we need to adjust the min and max points to the model boundaries with 10% tolerance to enhance the UI, not to use in any calculation because it is sure no element is out of the model boundaries.
        if (!!store.state.viewer && !!store.state.viewer.model) {
            let bBox = store.state.viewer.model.getBoundingBox();
            let MAX_SCALE = 5;
            let TOLERANCE = 0.1;

            let maxX = bBox.max.x;
            let maxY = bBox.max.y;
            let maxZ = bBox.max.z;
            let minX = bBox.min.x;
            let minY = bBox.min.y;
            let minZ = bBox.min.Z;

            let canUpdateX = Math.abs(maxPoint.x - minPoint.x) > MAX_SCALE * Math.abs(maxX - minX);
            let canUpdateY = Math.abs(maxPoint.y - minPoint.y) > MAX_SCALE * Math.abs(maxY - minY);
            let canUpdateZ = Math.abs(maxPoint.z - minPoint.z) > MAX_SCALE * Math.abs(maxZ - minZ);

            // Check the minimum point. 
            let x = minPoint.x;
            let y = minPoint.y;
            let z = minPoint.z;

            if (canUpdateX) {
                if (x < minX) x = minX - minX * TOLERANCE; else if (x > maxX) x = maxX + maxX * TOLERANCE;
            }

            if (canUpdateY) {
                if (y < minY) y = minY - minY * TOLERANCE; else if (y > maxY) y = maxY + maxY * TOLERANCE;
            }

            if (canUpdateZ) {
                if (z < minZ) z = minZ - minZ * TOLERANCE; else if (z > maxZ) z = maxZ + maxZ * TOLERANCE;
            }

            minPoint = new THREE.Vector3(x, y, z);

            // Check the maximum point. 
            x = maxPoint.x;
            y = maxPoint.y;
            z = maxPoint.z;

            if (canUpdateX) {
                if (x < minX) x = minX - minX * TOLERANCE; else if (x > maxX) x = maxX + maxX * TOLERANCE;
            }

            if (canUpdateY) {
                if (y < minY) y = minY - minY * TOLERANCE; else if (y > maxY) y = maxY + maxY * TOLERANCE;
            }

            if (canUpdateZ) {
                if (z < minZ) z = minZ - minZ * TOLERANCE; else if (z > maxZ) z = maxZ + maxZ * TOLERANCE;
            }

            maxPoint = new THREE.Vector3(x, y, z);

            // Check if the level bounding box points are overlapped on any axis because it will be a rectangle, not a cube.
            // In those checks, with considering of tolerance 10%.
            // For example: if the points equals in X, then we need check the X value is bBox.max.x, or bBox.min.x
            // And if it the bBox.max.x we leave the maxPoint.x and change the bBox.min.x to bBox.min.x and versa versa.

            if (Math.abs(maxPoint.x - minPoint.x) < TOLERANCE) {
                if (Math.abs(maxPoint.x - (maxX + maxX * TOLERANCE)) < TOLERANCE) {
                    minPoint.x = (minX - minX * TOLERANCE);
                } else {
                    maxPoint.x = (maxX + maxX * TOLERANCE);
                }
            }

            if (Math.abs(maxPoint.y - minPoint.y) < TOLERANCE) {
                if (Math.abs(maxPoint.y - (maxY + maxY * TOLERANCE)) < TOLERANCE) {
                    minPoint.y = (minY - minY * TOLERANCE);
                } else {
                    maxPoint.y = (maxY + maxY * TOLERANCE);
                }
            }

            if (Math.abs(maxPoint.z - minPoint.z) < TOLERANCE) {
                if (Math.abs(maxPoint.z - (maxZ + maxZ * TOLERANCE)) < TOLERANCE) {
                    minPoint.z = (minZ - minZ * TOLERANCE);
                } else {
                    maxPoint.z = (maxZ + maxZ * TOLERANCE);
                }
            }
        }
        
        return new THREE.Box3(minPoint, maxPoint);
    }
    getGlobalCropBox() {
        const minPt = new THREE.Vector3(this.west, this.south, this.bottomElevation);
        const maxPt = new THREE.Vector3(this.east, this.north, this.topElevation);
        return new THREE.Box3(minPt, maxPt);
    }
    clone() {
        var copy = new ForgeLevel();
        copy.id = this.id;
        copy.name = this.name;
        copy.planUrn = this.planUrn;
        copy.planImageUrl = this.planImageUrl;
        copy.bottomElevation = this.bottomElevation;
        copy.topElevation = this.topElevation;
        copy.east = this.east;
        copy.west = this.west;
        copy.north = this.north;
        copy.south = this.south;
        copy.mappingViewersPointsInfo = this.mappingViewersPointsInfo;
        copy.dbidsList = this.dbidsList;
        copy.isShowingIn3D = this.isShowingIn3D;
        return copy;
    }
    hasAllMappingInfo() {
        if (!this.mappingViewersPointsInfo
            || !this.mappingViewersPointsInfo.min || !this.mappingViewersPointsInfo.max)
            return false;
        return true;
    }
    isPoint1Valid() {
        if (this.mappingViewersPointsInfo == null
            || this.mappingViewersPointsInfo.min == null)
            return false;
        return true;
    }
    isPoint2Valid() {
        if (this.mappingViewersPointsInfo == null
            || this.mappingViewersPointsInfo.max == null)
            return false;
        return true;
    }
    containsElevation(elevation) {
        return this.bottomElevation < elevation && this.topElevation > elevation;
    }
    static parseLevelsFromDB(levels) {
        var result = levels.map(o => Object.assign(new ForgeLevel(), o));
        for (var i = 0; i < result.length; i++) {
            if (result[i].mappingViewersPointsInfo) {
                result[i].mappingViewersPointsInfo = Object.assign(new MappingViewersInfo(), result[i].mappingViewersPointsInfo);

                if(result[i].mappingViewersPointsInfo.min)
                    result[i].mappingViewersPointsInfo.min = Object.assign(new THREE.Vector3(), result[i].mappingViewersPointsInfo.min);
                if(result[i].mappingViewersPointsInfo.max)
                    result[i].mappingViewersPointsInfo.max = Object.assign(new THREE.Vector3(), result[i].mappingViewersPointsInfo.max);
            }
        }
        store.state.forgeService.sortByName(result);
        return result;
    }
    filterImagesInside(images) {
        let cropBox = this.getGlobalCropBox();
        return images.filter(o => cropBox.containsPoint(o.forgeCameraPosition));
    }
    isImageInsideLevel(image) {
        let cropBox = this.getGlobalCropBox();
        return cropBox.containsPoint(image.forgeCameraPosition);
    }
    fillAlignment(point1OnLevel,point1OnModel,point2OnLevel,point2OnModel){
        let minPt2d = new THREE.Box3().setFromPoints([point1OnLevel, point2OnLevel]).min
        let minPt3d = new THREE.Box3().setFromPoints([point1OnModel, point2OnModel]).min

        let oldBox = store.state.planViewer.model.getBoundingBox()
        var dist3d = toPoint2D(point1OnModel).distanceTo(toPoint2D(point2OnModel));
        var dist2d = toPoint2D(point1OnLevel).distanceTo(toPoint2D(point2OnLevel));
        let distanceToMin2d = toPoint2D(oldBox.min).distanceTo(toPoint2D(minPt2d))
        let ratio2d_3d = dist3d / dist2d
        let movingDist = distanceToMin2d * ratio2d_3d;

        let movingVec = toPoint2D(oldBox.min).sub(toPoint2D(minPt2d)).normalize().multiplyScalar(movingDist)
        let newMin = toPoint2D(minPt3d).add(movingVec);
        newMin.setZ(store.state.selectedLevel.getViewCropBox().center().z)

        let newWidth = (oldBox.max.x - oldBox.min.x) * ratio2d_3d;
        let newHeight = (oldBox.max.y - oldBox.min.y) * ratio2d_3d;
        let newMax = new THREE.Vector3(newMin.x + newWidth, newMin.y + newHeight, newMin.z)
        if(!this.mappingViewersPointsInfo)
            this.mappingViewersPointsInfo = new MappingViewersInfo();
        this.mappingViewersPointsInfo.min = newMin;
        this.mappingViewersPointsInfo.max = newMax;
    }
}
export class ForgeProject {
    constructor() {
        this.id;
        this.name = '';
        this.images = [];

        this.isVisable = true;
        this.isShowingIn3D = false;
        this.isExpanded = false;
    }
    setAllImagesVisable(isVisable) {
        this.images.forEach(o => o.isVisable = isVisable);
    }
    setAllImagesVisibleInViewers(isVisibleInViewers) {
        this.images.forEach(o => o.isVisibleInViewers = isVisibleInViewers);
    }
    static parseProjectsFromDB(projects) {
        var result = projects.map(o => Object.assign(new ForgeProject(), o));
        for (var i = 0; i < result.length; i++) {
            result[i].images = result[i].images.map(o => Object.assign(new Image360(), o));
            for (var j = 0; j < result[i].images.length; j++) {
                if (result[i].images[j].latLong) {
                    if (!result[i].images[j].forgeCameraPosition && result[i].images[j].latLong.isIndianSystem)
                        result[i].images[j].forgeCameraPosition = convertLatLongToXYZCoordinates_Indian(result[i].images[j].latLong);
                    if (!result[i].images[j].lockedForgeDirection ||
                        (result[i].images[j].lockedForgeDirection.x == 0 && result[i].images[j].lockedForgeDirection.y == 0 && result[i].images[j].lockedForgeDirection.z == 0))
                        result[i].images[j].lockedForgeDirection = getRotatedDirectionByNorthAngle();
                }
                result[i].images[j].forgeCameraPosition = Object.assign(new THREE.Vector3(), result[i].images[j].forgeCameraPosition);
                result[i].images[j].lockedForgeDirection = Object.assign(new THREE.Vector3(), result[i].images[j].lockedForgeDirection);
                //TODO: remove later
                if (!result[i].images[j].scanType)
                    result[i].images[j].scanType = 'faro';
            }
        }
        store.state.forgeService.sortByName(result);
        result.forEach(o => store.state.forgeService.sortByName(o.images));
        return result;
    }
    clone() {
        var copy = new ForgeProject();
        copy.id = this.id;
        copy.name = this.name;
        copy.images = this.images.map(o => o);
        return copy;
    }

}
export class Image360 {
    constructor() {
        this.id;
        this.name;
        this.isLocked;
        this.lockedPitch;
        this.lockedYaw;
        this.lockedForgeDirection;
        this.forgeCameraPosition;
        this.imageUrl;
        this.viewerLockedState;
        this.latLong;
        this.rotationX;
        this.rotationY;
        this.rotationZ;
        this.rotationAngle;
        this.scanType = '';//faro || leica || gps || geoslam
        this.createdOn = '';
        this.createdBy = '';

        this.isSelected = false;//checked
        this.isVisable = true;//filtered by search
        this.isShown = false;
        this.isVisibleInViewers = false;
    }
    get thumbnailURL() {
        if (!this.imageUrl)
            return '';
        return this.imageUrl.replace(store.state.assetId + '%2Fimages360', store.state.assetId + '%2Fimages360Thumbnails');
    }
    static getDefaultLockDirection() {
        return new THREE.Vector3(-1, 0, 0);
    }
    getCameraPositionInViewer() {
        return store.state.forgeService.worldToView3d(this.forgeCameraPosition, this.forgeCameraPosition)
    }
    storeLockingInformation(forgeService, forgeViewer) {
        store.state.selectedImage.lockedYaw = forgeService.panoramaViewer.getYaw();
        store.state.selectedImage.lockedPitch = forgeService.panoramaViewer.getPitch();
        store.state.selectedImage.lockedForgeDirection = forgeViewer.navigation.getCamera().getWorldDirection();
        store.state.selectedImage.forgeCameraPosition = forgeViewer.navigation.getPosition().clone().add(store.state.viewer.model.getGlobalOffset());
        store.state.selectedImage.isLocked = true;
    }
    clone() {
        let copy = new Image360();
        copy.id = this.id;
        copy.name = this.name;
        copy.scanType = this.scanType;
        copy.isLocked = this.isLocked;
        copy.lockedPitch = this.lockedPitch;
        copy.lockedYaw = this.lockedYaw;
        copy.rotationX = this.rotationX;
        copy.rotationY = this.rotationY;
        copy.rotationZ = this.rotationZ;
        copy.rotationAngle = this.rotationAngle;
        copy.lockedForgeDirection = this.lockedForgeDirection ? this.lockedForgeDirection.clone() : this.lockedForgeDirection;
        copy.forgeCameraPosition = this.forgeCameraPosition ? this.forgeCameraPosition.clone() : this.forgeCameraPosition;
        copy.imageUrl = this.imageUrl;
        copy.viewerLockedState = this.viewerLockedState;
        copy.latLong = this.latLong ? this.latLong.clone() : null;
        return copy;
    }
}

export class LatLongInfo {
    constructor() {
        this.lat = 0.0;
        this.long = 0.0;
        this.angle = 0.0;
        this.altitude = 0.0;
        this.isIndianSystem = false;
    }
    clone() {
        let copy = new LatLongInfo();
        copy.lat = this.lat;
        copy.long = this.long;
        copy.angle = this.angle;
        copy.altitude = this.altitude;
        copy.isIndianSystem = this.isIndianSystem;
        return copy;
    }
}

export class DocHubDocument { 
    constructor() {
        this.id = 0;
        this.documentNumber = null
        this.documentTitle = null
        this.fileName = null
        this.fileType = null
        this.documentTypeId = 0
        this.extension = null
    }

    clone () {

    }
}

export class ForgeAttachment {
    constructor() {
        this.id;
        this.guid = '';
        this.name = '';
        this.url = '';
        this.absoluteUrl = '';
        this.imageUrl = '';
        this.createdBy = '';
        this.createdOn = '';
        this.markupsCompiledPdfAbsolutePath = '';
        this.referenceDocumentId = '';
        this.referenceContextId = '';
        this.referenceContentId = '';
        this.isSelected = false;
        this.pagesMarkups = [];
    }
    clone() {
        var elem = new ForgeAttachment();
        elem.id = this.id;
        elem.guid = this.guid;
        elem.name = this.name;
        elem.url = this.url;
        elem.absoluteUrl = this.absoluteUrl;
        elem.imageUrl = this.imageUrl;
        elem.createdBy = this.createdBy;
        elem.createdOn = this.createdOn;
        elem.markupsCompiledPdfAbsolutePath = this.markupsCompiledPdfAbsolutePath;
        //The document that has attachment to it
        //Origin: DocumentFilePageID
        //Reality: DocHubDocument Id
        elem.referenceDocumentId = this.referenceDocumentId;
        //the container that has link to this attachment
        //For Origin: the id of the TestPackage/Issue
        //For Reality: the id of the Dochub, tag, annotation,… that has link to the attachment.
        elem.referenceContextId = this.referenceContextId;
        //Used as attachment content/folder in parent site
        elem.referenceContentId = this.referenceContentId;
        elem.pagesMarkups = this.pagesMarkups;
        return elem;
    }
    static parseAttachments(attachments) {
        let results = []
        if (!attachments)
            attachments = [];
        results = attachments.map(o => Object.assign(new ForgeAttachment(), o));
        results.forEach(o => {
            if (!o.pagesMarkups)
                o.pagesMarkups = [];
            o.pagesMarkups = o.pagesMarkups.map(e => Object.assign(new ForgePageMarkup(), e));
            o.pagesMarkups.forEach(o => {
                if (o.cropBox) {
                    o.cropBox = Object.assign(new THREE.Box3(o.cropBox.min, o.cropBox.max));
                }

                if (o.links) {
                    o.links = o.links.map(l => Object.assign(new ForgeMarkupLink(), l));
                }
            })
        });
        return results
    }
}
export class ForgePageMarkup {
    constructor() {
        this.id;
        this.guid;
        this.markupText = '';
        this.pageId;
        this.rotation = 0;
        this.imageUrl = '';
        this.imageAbsoluteUrl = '';
        this.svg = '';
        this.cropBox = null;
        this.links = [];
        this.comments = [];
        this.imageBase64 = ''; //DTO to send image to backend
    }
    clone() {
        var elem = new ForgePageMarkup();
        elem.id = this.id;
        elem.guid = this.guid;
        elem.markupText = this.markupText;
        elem.pageId = this.pageId;
        elem.rotation = this.rotation;
        elem.imageUrl = this.imageUrl;
        elem.imageAbsoluteUrl = this.imageAbsoluteUrl;
        elem.svg = this.svg;
        elem.cropBox = this.cropBox && this.cropBox.max ? this.cropBox.clone() : null;
        elem.links = this.links && this.links.length > 0 ? this.links.map(l => l.clone()) : null;
        elem.imageBase64 = this.imageBase64; 
        return elem;
    }
}
export class ForgeMarkupLink {
    constructor() {
        this.id;
        this.name = '';
        this.userId = '';
        this.createdOn = store.state.forgeService.dateTimeNow();
        this.createdBy = '';
        this.linkedAttachmentId = '';
        this.forgePageMarkupId = '';
        this.position;
        this.width;
        this.height;
        this.rotation;
        this.thumbnailUrl = '';
        this.type = '';
        this.metadata = '';
    }
    clone() {
        var elem = new ForgeMarkupLink();
        elem.id = this.id;
        elem.name = this.name;
        elem.userId = this.userId;
        elem.createdOn = this.createdOn;
        elem.createdBy = this.createdBy;
        elem.linkedAttachmentId = this.linkedAttachmentId;
        elem.forgePageMarkupId = this.forgePageMarkupId;
        elem.position = this.position;
        elem.width = this.width ? this.width : 1;
        elem.height = this.height ? this.height : 1;
        elem.rotation = this.rotation ? this.rotation : 0;
        elem.thumbnailUrl = this.thumbnailUrl;
        elem.type = this.type;
        elem.metadata = this.metadata;
        return elem;
    }
}
export class ForgeComment {
    constructor(parentId) {
        this.id = 0;
        this.text = '';
        this.createdBy = store?.state?.username ?? ''
        this.userId = store?.state?.userId;
        this.createdOn = store.state.forgeService.dateTimeNow();
        this.replies = [];
        this.parentId = parentId;
        this.isClosed = false;
        this.position;
        this.forgePageMarkupId = '';
    }
    clone() {
        var elem = new ForgeComment();
        elem.id = this.id;
        elem.text = this.text;
        elem.createdBy = this.createdBy;
        elem.userId = this.userId;
        elem.createdOn = this.createdOn;
        elem.replies = this.replies;
        elem.parentId = this.parentId;
        elem.isClosed = this.isClosed;
        elem.position = this.position;
        elem.forgePageMarkupId = this.forgePageMarkupId;
        return elem;
    }
}
export class ForgeModelVersion {
    constructor() {
        this.id;
        this.name = '';
        this.urn;
        this.createdBy = '';
        this.createdOn = '';
        this.version = '';
        this.isMainVersion = false;
        this.isSvf2 = true;

        this.thumbnailUrl = '';
        this.isShown = false;
        this.isSelected = false;
        this.isLoading = false;
    }
    getThumbnail(callback) {
        if (!this.urn || this.thumbnailUrl) {
            if (this.thumbnailUrl && callback)
                callback(this.thumbnailUrl)
            return;
        }
        var _this = this;
        getURNThumbnail(this.urn, thumb => {
            _this.thumbnailUrl = thumb;
            if (callback)
                callback(thumb)
        });
    }
}
export class ForgeCamera {
    constructor() {
        this.name = '';
        this.id;
        this.thumbnailUrl = '';
        this.viewerState = '';
        this.createdOn = '';
        this.createdBy = '';
        this.folderPath = '';
        this.visibleSmallModels = '';

        this.isSelected = false;
    }

    load() {
        if (this.visibleSmallModels && this.visibleSmallModels.length > 0) {
            let hiddenModels = store.state.uploadedModels.filter(m => !m.isShown);
            let modelsToShow = this.visibleSmallModels.split(',');
            if (modelsToShow && modelsToShow.length > 0) {
                hiddenModels.forEach(smallModel => {
                    if (modelsToShow.includes(smallModel.id.toString())) {
                        store.state.forgeService.toggleShowingModel(smallModel);
                    }
                });
            }
        }
        store.state.viewer.restoreState(JSON.parse(this.viewerState));
    }
}
export class ShareFileItem {
    constructor(name, id, isFolder, fileSizeBytes, url) {
        this.name = name;
        this.id = id;
        this.children = null;
        this.isFolder = isFolder;
        this.fileSize = bytesToSize(fileSizeBytes);
        this.url = url;

        this.isExpanded = false;
        this.isSelected = false;
    }
    setAllNotSelected(){
        this.isSelected = false;
        if(this.children)
            this.children.forEach(o=>o.setAllNotSelected());
    }
    setItemSelected(id){
        if(this.id == id){
            this.isSelected = true
            return
        }
        if(this.children)
            this.children.forEach(o=>o.setItemSelected(id));
    }
}
export class ForgeSettings {
    constructor() {
        this.gpsSettings = new GPSSettings();
        this.ignoredDbIds = "";
        this.modelUploadLimit = 50;
        this.isAMIS = false;
        this.inspectionFiltersColors = "[{\"code\":1,\"symbol\":\"A\",\"color\":\"#aaffff\"},{\"code\":1,\"symbol\":\"B\",\"color\":\"#7dff7d\"},{\"code\":1,\"symbol\":\"C\",\"color\":\"#ffff51\"},{\"code\":1,\"symbol\":\"D\",\"color\":\"#ffa346\"},{\"code\":1,\"symbol\":\"E\",\"color\":\"#a346ff\"},{\"code\":1,\"symbol\":\"F\",\"color\":\"#ff0000\"},{\"code\":1,\"symbol\":\"N/A\",\"color\":\"#0f7968\"},{\"code\":2,\"symbol\":\"A\",\"color\":\"#ceceff\"},{\"code\":2,\"symbol\":\"B\",\"color\":\"#adff5b\"},{\"code\":2,\"symbol\":\"C\",\"color\":\"#ffff00\"},{\"code\":2,\"symbol\":\"D\",\"color\":\"#ffaf60\"},{\"code\":2,\"symbol\":\"E\",\"color\":\"#9e3eff\"},{\"code\":2,\"symbol\":\"F\",\"color\":\"#ff0000\"},{\"code\":2,\"symbol\":\"N/A\",\"color\":\"#0f7968\"},{\"code\":3,\"symbol\":\"A\",\"color\":\"#ceceff\"},{\"code\":3,\"symbol\":\"B\",\"color\":\"#acff59\"},{\"code\":3,\"symbol\":\"C\",\"color\":\"#ffff00\"},{\"code\":3,\"symbol\":\"D\",\"color\":\"#ffa851\"},{\"code\":3,\"symbol\":\"E\",\"color\":\"#a244ff\"},{\"code\":3,\"symbol\":\"F\",\"color\":\"#ff0000\"},{\"code\":3,\"symbol\":\"N/A\",\"color\":\"#0f7968\"},{\"code\":4,\"symbol\":\"Over a year\",\"color\":\"#65AC50\"},{\"code\":4,\"symbol\":\"Less than a year\",\"color\":\"#FF5C0C\"},{\"code\":4,\"symbol\":\"Overdue\",\"color\":\"#ff0000\"},{\"code\":4,\"symbol\":\"Next Inspection date not provided\",\"color\":\"#0f7968\"}]";
        this.shareFileParentId = '';
        this.isInspectionsOn = false;
        // Default Options
        this.filterOptions = "[{\"name\":\"Model\",\"propertyName\":\"Model\",\"isChecked\":false},{\"name\":\"Discipline\",\"propertyName\":\"Discipline\",\"isChecked\":false},{\"name\":\"Work Pack\",\"propertyName\":\":WgeWorkPack\",\"isChecked\":false},{\"name\":\"P&ID\",\"propertyName\":\":WgePID\",\"isChecked\":false},{\"name\":\"Line Number\",\"propertyName\":\":WgeLINENO\",\"isChecked\":false}]"
    }

    getFilterOptionsArray() {
        if (this.filterOptions) {
            return JSON.parse(this.filterOptions).map(filter => {
                filter.isChecked = false;
                return filter
            });
        } else {
            return [];
        }
    }

    getInspectionFiltersColors() {
        let result = this.inspectionFiltersColors ? JSON.parse(this.inspectionFiltersColors) : [];

        let item1 = result.find(o => o.code == 4 && o.symbol == 'N/A');
        if (item1) item1.symbol = 'Next Inspection date not provided';

        let item2 = result.find(o => o.code == 4 && o.symbol == 'Lessthanayear');
        if (item2) item2.symbol = 'Less than a year';

        let item3 = result.find(o => o.code == 4 && o.symbol == 'Overayear');
        if (item3) item3.symbol = 'Over a year';
        
        return result;
    }
}
export class Category {
    constructor() {
        this.name = '';
        this.id = 0;
        this.color = '#ff0000';
        this.assetId = '';
    }
}
export class GPSSettings {
    constructor() {
        this.isIndianSystem = false;
        this.originN = '';
        this.originE = '';
        this.x = '';
        this.y = '';
        this.angle = '';
    }
    get CONST_A() {
        let theta = Math.degToRad(this.angle)
        return Math.sin(theta) * this.x - Math.cos(theta) * this.y;
    }
    get CONST_B() {
        let theta = Math.degToRad(this.angle)
        return - Math.cos(theta) * this.x - Math.sin(theta) * this.y;
    }
}
export class UserSettings {
    constructor() {
        this.id;
        this.displaySettings = new DisplaySettings();
    }
}
export class PointCloudDisplay {
    constructor() {
        this.showPointClouds = false;
        this.colorType = 'RGB';
        this.opacity = 100.0;
        this.rgbGamma = 100.0;
        this.rgbContrast = 0.0;
        this.rgbBrightness = 0.0;
        this.elevationMax = 100.0;
        this.elevationMin = 0.0;
        this.colorSchema = "RAINBOW";
        this.pointBudget = 100000;
        this.pointSize = 2.0;
        this.pointType = 'Circle';
        this.useEDL = false;
    }
}
export class DisplaySettings {
    constructor() {
        this.showMasterModel = true;
        this.masterModelTransparency = 100.0;
        this.renderFPS = 8;
        this.showSmallModels = false;
        this.smallModelsTransparency = 100.0;

        this.show360 = false;
        this.showInspections = false;
        this.showTags = false;
        this.showAutoEquipment = false;
        this.showStructural = false;
        this.showManualStructural = false;
        this.showPipelines = false;
        this.showManualPipelines = false;
        this.showAnnotations = false;
        this.showScaffolds = false;
        this.showDeckManagment = false;
        this.showPermits = false;
        this.showEquipmentPopup = false;
        this.showAnnotationPopup = false;
        this.showInspectionPopup = false;
        this.showStructuralPopup = false;
        this.showPipelinePopup = false;
        this.hideKeyboard = (window.localStorage.getItem(btoa("hideKeyboard")) != "false");
        this.visibilityRange = 10.0;

        this.displayUnits = 'm';

        this.pointCloudDisplay = new PointCloudDisplay();
    }
    getVisibilityRangeInViewer() {
        let result = this.getVisibilityRange();
        if (store.state.viewer && store.state.viewer.model)
            result = result / store.state.viewer.model.getUnitScale();
        return result;
    }
    getVisibilityRange() {
        if (this.visibilityRange == '100')
            return 1000000;//increase it so much in cas of max

        //TODO: convert here from meter to store.state.viewer units
        // let result = this.visibilityRange * 3.28084;

        return this.visibilityRange;
    }
    
    static get fpsLocalStorageKey () {
        return `FPS_${store.state.userId}_${store.state.assetId}`
    }
}
export class ModelBrowserItem {
    constructor(nodeId, nodeName) {
        let instanceTree = store.state.viewer?.model?.getInstanceTree();

        this.nodeId = nodeId;
        this.nodeName = nodeName;
        this.nodeParent = undefined;
        this.nodeChildren = [];
        this.isParent = false;

        // node forge properties
        this.properties = [];
        this.details = [];
        this.isExpanding = false;
        this.isExpanded = false;
        this.isVisible = true;
        this.isIsolated = instanceTree ? (!instanceTree.isNodeHidden(this.nodeId) && store.getters['getIsIsolating3D']) : false
        this.isSelected = false;
        this.isHighlighted = false;
        this.isFiltered = false;
        this.isDetailsLoaded = false;
    }    

    makeAllParentVisible() {
        if (!(this.nodeParent === undefined)) {
            this.nodeParent.isExpanded = true;
            this.nodeParent.makeAllParentVisible(this.nodeParent);
        }
    }

    makeAllChildrenVisible() {
        if (this.nodeChildren && this.nodeChildren.length > 0) {
            for (let n of this.nodeChildren) {
                // n.isIsolated = false;
                n.isVisible = true;
                n.isExpanded = false;
                n.makeAllChildrenVisible();
            }
        }
    }

    makeAllChildrenIsolated() {
        if (this.nodeChildren && this.nodeChildren.length > 0) {
            for (let n of this.nodeChildren) {
                n.isIsolated = true;
                n.isVisible = true;
                // n.isExpanded = false;
                n.makeAllChildrenIsolated();
            }
        }
    }

    makeAllChildrenIsolatedValue(value) {
        if (this.nodeChildren && this.nodeChildren.length > 0) {
            for ( let n of this.nodeChildren) {
                n.isIsolated = value;
                n.isVisible = true;
                n.makeAllChildrenIsolatedValue(value);
            }
        }
    }

    makeAllParentsIsolatedValue(value) {
        if (this.nodeParent) {
            this.nodeParent.isIsolated = value;
            this.nodeParent.makeAllParentsIsolatedValue(value);
        }
    }

    // Build all the node children till leafs.
    // In case the node is the root node, then it will build all the tree.
    build() {
        let tree = store.state.viewer?.model?.getInstanceTree();
        tree.enumNodeChildren(this.nodeId, (childNodeId) => {
            let childNode = new ModelBrowserItem(
                childNodeId,
                tree.getNodeName(childNodeId)
            );

            childNode.nodeParent = this;
            childNode.isIsolated = !tree.isNodeHidden(this.nodeId) && store.getters['getIsIsolating3D']
            childNode.isParent = tree.getChildCount(childNodeId) != 0;
            childNode.build();

            this.nodeChildren.push(childNode)
            
            store.dispatch('pushToAllModelItems', { value: childNode });
        }, false)
    }

    // It will build only the next level of children for the node.
    // It used to extend the parent node.
    buildOneLevel(callback) {
        console.log(`🔎 Build One Level for Node: ${this.nodeId}`);
        this.isExpanding = true;

        let instanceTree = store.state.viewer?.model?.getInstanceTree();
        let treeIds = store.getters['getTreeIds'];
        let allModelItems = store.getters['getAllModelItems'];
        var cbCount = instanceTree.getChildCount(this.nodeId);

        instanceTree.enumNodeChildren(this.nodeId, (childNodeId) => {
            cbCount--;

            if (!allModelItems.find(n => n.nodeId == childNodeId)) {
                if (treeIds.length == 0 || treeIds.includes(childNodeId) || childNodeId == 0 || childNodeId == 1) {
                    let childNode = new ModelBrowserItem(
                        childNodeId,
                        instanceTree.getNodeName(childNodeId)
                    );
                    
                    childNode.nodeParent = this;

                    if (instanceTree.getChildCount(childNodeId) != 0 && !store.getters['getLeafIds'].includes(childNodeId)) {
                        childNode.isParent = true;
                        childNode.isIsolated = instanceTree ? (!instanceTree.isNodeHidden(this.nodeId) && store.getters['getIsIsolating3D']) : false

                        if (treeIds.length != 0) {
                            childNode.isExpanded = true;
                        }
                    }

                    this.nodeChildren.push(childNode)

                    store.dispatch('pushToAllModelItems', { value: childNode });
                }

            }

            if (cbCount == 0) {
                // this.isExpanding = false;
                if (callback) callback();
            }
        }, false)
    }

    // It will build only the next level of children for the node.
    // It used to extend the parent node if it contains a huge mount of children.
    buildOneElementOnLevel(childNodeId) {
        let instanceTree = store.state.viewer?.model?.getInstanceTree();
        let treeIds = store.getters['getTreeIds'];

        if (treeIds.length == 0 || treeIds.includes(childNodeId) || childNodeId == 0 || childNodeId == 1) {
            let childNode = new ModelBrowserItem(
                childNodeId,
                instanceTree.getNodeName(childNodeId)
            );

            childNode.nodeParent = this;

            if (instanceTree.getChildCount(childNodeId) != 0 && !store.getters['getLeafIds'].includes(childNodeId)) {
                childNode.isParent = true;
                childNode.isIsolated = instanceTree ? (!instanceTree.isNodeHidden(this.nodeId) && store.getters['getIsIsolating3D']) : false

                if (treeIds.length != 0) {
                    childNode.isExpanded = true;
                }
            }

            this.nodeChildren.push(childNode)

            store.dispatch('pushToAllModelItems', { value: childNode });
        }
    }

    // It will build the tree from the node point to reach all treeIds only.
    // It use with search by name in the standard mode.
    // treeIds => it is an array of filtered nodes ids.
    buildTreeFromTreeIds() {
        let instanceTree = store.state.viewer?.model?.getInstanceTree();
        let treeIds = store.getters['getTreeIds'];

        instanceTree.enumNodeChildren(this.nodeId, (childNodeId) => {
            if (treeIds.includes(childNodeId)) {
                let childNode = new ModelBrowserItem(
                    childNodeId,
                    instanceTree.getNodeName(childNodeId)
                );

                childNode.nodeParent = this;

                if (instanceTree.getChildCount(childNodeId) != 0) {
                    childNode.isParent = true;

                    if (!store.getters['getLeafIds'].includes(childNodeId)) {
                        childNode.isExpanded = true;
                        childNode.isIsolated = instanceTree ? (!instanceTree.isNodeHidden(this.nodeId) && store.getters['getIsIsolating3D']) : false
                    } else {
                        childNode.isExpanded = false;
                    }
                }

                childNode.buildTreeFromTreeIds();

                this.nodeChildren.push(childNode)

                store.dispatch('pushToAllModelItems', { value: childNode });
            }
        }, false)
    }
    
    // Get filtered and sorted node properties.
    // IMPORTANT:: It is contains a temporary check. 
    getElementProperties() {
        let ignoredProperties = ["child", "parent", "viewable_in", "source file", "project", "user", "last saved by"]

        if (!store.state.viewer) return;

        getNodeSortedProperties(store.state.viewer, this.nodeId).then(forgeProperties => {
            this.details = forgeProperties.reduce(function (result, { displayName, displayValue }) {
                if (!ignoredProperties.includes(displayName.toLowerCase())) {
                    result.push({
                        displayName,
                        displayValue: displayValue !== undefined ? displayValue : "",
                    });
                }
                return result;
            }, []);

            // TODO: Remove it when it is unused.
            if (store.state.assetId == "171") {
                let property = this.details.find(p => p.displayName.toLowerCase() === 'name' && p.displayValue.includes("York"));
                if (property) {
                    property.displayValue = property.displayValue.replace("York", "");
                }
            }
        })
    }

    // Check the leaf parents, and if there is any parent not created yet, create and build it to the leaf node.
    checkToLeaf(parents, nodeId) {
        let instanceTree = store.state.viewer?.model?.getInstanceTree();

        let children = this.nodeChildren.filter(n => parents.includes(n.nodeId));

        let nextChild = children ? children[0] : null;

        if (nextChild) {
            parents = parents.filter(n => n != nextChild.nodeId);

            nextChild.checkToLeaf(parents, nodeId);

            this.isExpanded = true;
            this.isParent = true;
        } else {
            if (parents.length == 0 && this.nodeId == nodeId) {
                instanceTree.enumNodeChildren(this.nodeId, (childNodeId) => {

                    let childNode = new ModelBrowserItem(
                        childNodeId,
                        instanceTree.getNodeName(childNodeId)
                    );

                    childNode.isParent = false;
                    childNode.isExpanded = false;
                    childNode.nodeParent = this;
                    childNode.build();

                    this.nodeChildren.push(childNode)

                    store.dispatch('pushToAllModelItems', { value: childNode });
                }, false)

                return
            }

            let current = parents[0];

            parents = parents.filter(n => n != current);

            let childrenCount = instanceTree.getChildCount(this.nodeId);

            if (childrenCount < 7000) {
                this.buildOneLevel();
            } else {
                this.buildOneElementOnLevel(current);
            }

            nextChild = store.getters['getAllModelItems'].filter(n => n.nodeId == current)[0];

            if (parents.length == 0) {
                nextChild.isParent = false;
                nextChild.isExpanded = false;
            } else {
                nextChild.isParent = true;
                nextChild.isExpanded = true;
                nextChild.checkToLeaf(parents, nodeId);
            }
        }
    }
}

export class ForgeMarkupStamp {
    constructor() {
        this.id;
        this.folderPath = '';
        this.userId;
        this.createdOn;
        this.createdBy = '';
        this.name = '';
        this.svgText = '';
    }
    clone() {
        var obj = new ForgeMarkupStamp();
        obj.id = this.id;
        obj.folderPath = this.folderPath;
        obj.userId = this.userId;
        obj.createdOn = this.createdOn;
        obj.createdBy = this.createdBy;
        obj.name = this.name;
        obj.svgText = this.svgText;
        return obj;
    }
}

export class ForgeAppearanceOptions{
    constructor() {
        this.forgeVisiblityMode = ForgeVisiblityMode.ISOLATE;
        this.selectionMode = 0; //Autodesk.Viewing.SelectionMode
        this.selectionType = 0; //Autodesk.Viewing.SelectionType
        this.colorHexOverride = '';
        this.isZoomToFit = false;
        this.clear = false;
    }
    clone() {
        var obj = new ForgeAppearanceOptions();
        obj.forgeVisiblityMode = this.forgeVisiblityMode;
        obj.selectionMode = this.selectionMode;
        obj.selectionType = this.selectionType;
        obj.colorHexOverride = this.colorHexOverride;
        obj.isZoomToFit = this.isZoomToFit;
        obj.clear = this.clear;
        return obj;
    }
    hexToVector4(hex) {
        var c;
        if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if(c.length == 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');

            return new THREE.Vector4(((c >> 16) & 255) / 255, ((c >> 8) & 255) / 255, (c & 255) / 255, 1);
        }
        throw new Error('Bad Hex');
    }
}

